export const SESSION_DURATION_MINUTES = 15 * 24 * 60 // 15 days

export const EMAIL_REGEX = /^[^@ ]+@[0-9A-Za-z-]+(\.[0-9A-Za-z-]+)+$/

function getStageLinkMatch(text: string) {
  const pattern = /\b\w+-app\b/
  const matches = text.match(pattern)
  return matches && matches.length > 0 ? matches[0] : null
}

export const localHostnames = ['localhost', '127.0.0.1', '[::1]']

export function getOrgSlug(): string | null {
  const host = window.location.hostname
  const domainParts = host.split('.')
  const firstPart = domainParts[0]

  if (
    domainParts.length > 1 &&
    firstPart !== 'app' &&
    !localHostnames.includes(firstPart) &&
    !getStageLinkMatch(firstPart)
  ) {
    return firstPart // Return the subdomain as org slug
  }
  return null
}

export function getGlobalBaseUrl(
  subdomain: string,
  url: string = window.location.href,
): string {
  return url.replace(`${subdomain}.`, '')
}

export function updateUrlWithSubdomain(
  subdomain: string,
  url: string = window.location.href,
): string {
  const currentSubdomain = getOrgSlug()
  if (currentSubdomain) {
    url = getGlobalBaseUrl(currentSubdomain, url)
  }
  const urlInstance = new URL(url)
  return url.replace(
    `${urlInstance.protocol}//`,
    `${urlInstance.protocol}//${subdomain}.`,
  )
}

export function getRedirectUrl(): string {
  const currentSubdomain = getOrgSlug()
  const baseUrl = currentSubdomain
    ? getGlobalBaseUrl(currentSubdomain, window.location.origin)
    : window.location.origin

  const params = new URLSearchParams()
  if (currentSubdomain) {
    params.set('org_slug', currentSubdomain)
  }

  const returnTo = new URLSearchParams(window.location.search).get('return_to')
  if (returnTo) {
    params.set('return_to', returnTo)
  }
  return `${baseUrl}/authenticate?${params.toString()}`
}

export function sanitizeReturnTo(path: string): string {
  // Decode before validating so encoded slashes can't sneak past the checks
  try {
    path = decodeURIComponent(path)
  } catch {
    return '/'
  }

  // If path doesn't start with '/', remove everything before the first '/'
  if (!path.startsWith('/')) {
    const firstSlashIndex = path.indexOf('/')
    if (firstSlashIndex === -1) {
      return '/'
    }

    path = path.substring(firstSlashIndex)
  }

  // Collapse leading slashes/backslashes so protocol-relative URLs
  // (//evil.com, /\evil.com) can't survive
  return path.replace(/^[/\\]+/, '/')
}
